import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker as DP } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker as DTP } from '@mui/x-date-pickers/DateTimePicker';

import { endOfDay, parseISO } from 'date-fns';
import enGB from 'date-fns/locale/en-GB';

const DatePicker = ({ name, value, label, onChange, showTime, isEndOfDay, required, locale, helperText, error, size, clearable, minDate, maxDate, ...props }) => {
	const min = minDate ? parseISO(minDate) : new Date('01/01/1930');
	const max = maxDate ? parseISO(maxDate) : new Date('01/01/2060');

	const handleDateValue = (dateValue) => {
		if (dateValue instanceof Date && !isNaN(dateValue)) return dateValue;
		const v = parseISO(dateValue);
		const isValid = !isNaN(v);
		if (isValid) return v;
		return null;
	};

	const handleOnChange = (value) => {
		const v = isEndOfDay ? endOfDay(value) : value;
		const inRange = v >= min && v <= max;
		onChange({ target: { name, value: (v && inRange) ? v.toISOString() : null } });
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale || enGB}>
			{showTime
				? <DTP
					label={label}
					ampm={false}
					value={handleDateValue(value)}
					onChange={handleOnChange}
					minDate={min}
					maxDate={max}
					slotProps={{
						field: {
							clearable,
						},
						textField: {
							fullWidth: true,
							helperText: helperText || '',
							required,
							error,
							size,
						},
					}}
					{...props}
				/>
				: <DP
					label={label}
					value={handleDateValue(value)}
					onChange={handleOnChange}
					minDate={min}
					maxDate={max}
					slotProps={{
						field: {
							clearable,
						},
						textField: {
							fullWidth: true,
							helperText: helperText || '',
							required,
							error,
							size,
						},
					}}
					{...props}
				/>}
		</LocalizationProvider>
	);
};

DatePicker.type = 'DatePicker';
DatePicker.spec = [{
	name: 'DatePicker',
	key: 'DatePicker',
	category: 'input',
	title: 'Date',
	icon: 'Calendar',
	translatable: ['label', 'placeholder'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'TextField',
		label: 'Placeholder',
		name: 'placeholder',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}],
}];

export default DatePicker;
